











import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message, DatePicker,
} from 'element-ui';
import MyNav from '@/components/nav/BackNav'; // nav
import NProgress from 'nprogress';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import Read from '../../servers/modules/read/read'; // server
import learning from './readingInstructionsModel/learning.vue';

Vue.use(Loading.directive);
    @Component({
      components: {
        MyNav,
        Table,
        TableColumn,
        Scrollbar,
        Button,
        DatePicker,
        learning,
      },
    })
export default class extends Vue {
        @Mutation public setSkeletonDescribe;

        @Mutation public setNavData;

        @Getter public navData: any;

        @Getter public skeleton: any;

        @Getter public basicData: any;

        @Getter public vteBasicData: any;

        @Getter public title: any;

        private startTime: any = '';

        private endTime: any = '';

        private operat: string = '1';

        private tableHeaderClassName() {
          return 'table-header';
        }

        private tableRowClassName() {
          return 'table-row';
        }

        private tableData:any = [];

        private gameData:any = [];

        private back() {
          this.$router.push('/read')
        }

        private created() {
          this.setSkeletonDescribe(true);
          NProgress.start();
          // title
          // this.title = this.title;//window.LS.get('vteData').course.courseTitle;
          NProgress.done();
          this.setSkeletonDescribe(false);
        }

        // 切换下方表格
        private changeTable(type:string) {
          this.operat = type;
        }

        private change() {
          // 调用子组件方法进行更新页面
          this.$refs.learning.initLoad('init');
        }
}
